export const THEMES = {
  RESTAURANT: "1",
  BAR: "2",
  BEACH: "3",
};
